import { getErrorMessage } from "../locales/translationUtils";
import api from "./api";

export const postExportList = async (type: string, filters: any) => {
    try {
        const url: string = `/CargoInfo/report`;

        const params = new Map<string, string>();
        for (const key of Object.keys(filters)) {
            if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
                params.set(key, String(filters[key]));
            }
        }

        const query = new URLSearchParams(params as unknown as Record<string, string>).toString();

        return await api.get(`${url}/${type}?${query}`, {
            headers: {
                Accept: 'application/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf'
            },
            responseType: 'blob'
        });
    } catch (error) {
        console.error(getErrorMessage("fetchExportListError", {}));
        throw error;
    }
};
